import React from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'pcln-design-system'
import FormattedIcon from './FormattedIcon'

const FormattedIconRow = ({
  carryOnAvailability,
  seatAvailability,
  checkedBagAvailability,
  wifiAvailability,
}) => (
  <Flex justifyContent={'center'}>
    <FormattedIcon name='CARRY_ON' description='Carry-on bags' inclusion={carryOnAvailability} />
    <FormattedIcon name='SEATS' description='Advance seat selection' inclusion={seatAvailability} size='17' />
    <FormattedIcon name='CHECKED_BAG' description='Checked bags' inclusion={checkedBagAvailability} />
    {wifiAvailability && wifiAvailability !== 'NOT_INCLUDED' && (
      <FormattedIcon name='WIFI' description='WiFi' inclusion={wifiAvailability} size='17' />
    )}
  </Flex>
)

FormattedIconRow.propTypes = {
  carryOnAvailability: PropTypes.bool,
  seatAvailability: PropTypes.bool,
  checkedBagAvailability: PropTypes.bool,
  wifiAvailability: PropTypes.bool,
}

export default FormattedIconRow
